import { TFunction } from 'i18next'
import moment from 'moment'
import { EventLogName } from '../common/constants/EventLogName'

const getExtension = (value: string): string => {
  const trimmed = value.trim().toLowerCase()
  const lastDot = trimmed.lastIndexOf('.')
  if (lastDot !== -1 && lastDot < trimmed.length - 1) {
    return trimmed.slice(lastDot + 1)
  }
  return trimmed
}

export const getInvoiceFileTypeLabel = (raw: string | undefined, t: TFunction): string => {
  if (!raw) return ''

  const normalized = raw.trim().toLowerCase()
  const extension = getExtension(normalized)

  if (
    normalized.startsWith('image/') ||
    ['jpg', 'jpeg', 'png', 'image/jpg', 'image/jpeg', 'image/png'].includes(extension) ||
    ['jpg', 'jpeg', 'png', 'image/jpg', 'image/jpeg', 'image/png'].includes(normalized)
  ) {
    return t('VIEW_TICKET_MODAL.FILE_TYPE.IMAGE')
  }

  if (normalized === 'pdf' || normalized === 'application/pdf' || extension === 'pdf') {
    return t('VIEW_TICKET_MODAL.FILE_TYPE.PDF')
  }

  return raw.toUpperCase()
}

export const formatEventLogDetails = (event: string, details: string, rtl?: boolean): string => {
  if (event !== EventLogName.Payment_Pending || !details) return details

  const trimmed = details.trim()
  if (trimmed.startsWith('[')) return trimmed   // legacy pre-formatted row

  const parsed = moment(trimmed)
  if (!parsed.isValid()) return trimmed

  return `[Expires at: ${parsed.locale(rtl ? 'ar-SA' : 'en-US').format('HH:mm')}]`
}
